const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container copyright text-center mt-4">
        <p><strong className="px-1 sitename">Z Solutions SRL</strong><span>- P.IVA e dati societari disponibili su richiesta ufficiale.</span></p>
        <div className="credits">
          {/* All the links in the footer should remain intact. */}
          {/* You can delete the links only if you've purchased the pro version. */}
          {/* Licensing information: https://bootstrapmade.com/license/ */}
          {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
        </div>
      </div>
    </footer>
  );
}
export default Footer;